import { MapPin, PhoneCall } from "lucide-react";
import { BRAND } from "@/data/content";
import { useEffect, useState } from "react";

export function HeroSection({ t, image }) {
    const [shift, setShift] = useState(0);

    useEffect(() => {
        const onScroll = () => setShift(Math.min(window.scrollY * 0.055, 34));
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <section
            id="accueil"
            className="hero"
            style={{ backgroundImage: `url(${image.url})`, backgroundPosition: `center ${50 + shift / 12}%` }}
            data-testid="reset365-hero-section"
        >
            <div className="hero__inner page-width">
                <div className="hero__copy">
                    <p className="eyebrow hero__eyebrow" data-testid="reset365-hero-eyebrow">{t.hero.eyebrow}</p>
                    <h1 className="hero__title" data-testid="reset365-hero-title">
                        {t.hero.titleLines.map((line, index) => (
                            <span className="hero__title-line" style={{ "--line-delay": `${index * 110}ms` }} key={`${line}-${index}`}>{line}</span>
                        ))}
                    </h1>
                    <p className="hero__body" data-testid="reset365-hero-subtitle">{t.hero.body}</p>
                    <div className="hero__actions">
                        <a href="#soumission" className="button button--light" data-testid="reset365-hero-quote-btn">{t.hero.primaryCta}</a>
                        <a href={BRAND.phoneHref} className="button button--outline-light" data-testid="reset365-hero-call-btn"><PhoneCall size={17} aria-hidden="true" />{t.hero.secondaryCta}</a>
                    </div>
                    <div className="hero__trust" data-testid="reset365-hero-trust-line"><span className="hero__trust-dot" aria-hidden="true" /><span>{t.hero.trust}</span></div>
                </div>
                <div className="hero__side-note reveal" data-testid="reset365-hero-local-note">
                    <div className="hero__side-number">365</div>
                    <div className="hero__side-rule" />
                    <div className="hero__side-label"><MapPin size={16} aria-hidden="true" /><span>{t.hero.locationLabel}</span></div>
                    <strong>{t.hero.locationText}</strong>
                    <a href={BRAND.phoneHref} data-testid="reset365-hero-phone">{BRAND.phone}</a>
                </div>
            </div>
        </section>
    );
}
